import { createFileRoute } from "@tanstack/react-router";
import { SuggestionCenterPage } from "@client/components/suggestion-center/suggestion-center-page";

export const Route = createFileRoute("/_app/suggestions")({
  component: SuggestionCenter,
});

function SuggestionCenter() {
  return <SuggestionCenterPage />;
}
